// @flow

import * as React from 'react';
import HorizontalScroll from 'react-scroll-horizontal';

type Props = {
  children: React.Node,
  length: number,
};

const ScrollWrapper = (props: Props) =>
  props.length > 3 && window.innerWidth > 992 ? (
    <HorizontalScroll reverseScroll={true}>{props.children}</HorizontalScroll>
  ) : (
    <div className="category-links">{props.children}</div>
  );

export default ScrollWrapper;



// WEBPACK FOOTER //
// ./src/containers/Category/ScrollWrapper.js